export default "__VITE_ASSET__UKNCa3cC__"